module.exports = __webpack_public_path__ + "static/vf_mcoats_core.bd2d2525.svg";